var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"block"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"background":"","page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.editPageSizes,"current-change":_vm.handleCurrentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }